import ApolloClient, { InMemoryCache } from 'apollo-boost';
import { getPreference } from '@ugc-utils/preference';
import { isPreprod, isProd } from '@ugc-utils/utils';

const getBaseUrl = () => {
  if (isProd()) return 'https://graphql-catalog.app.iherb.com';
  if (isPreprod()) return 'https://graphql-gateway.app.iherbpreprod.com';
  return 'https://graphql-gateway.app.iherbtest.com';
};

let client;

export const createApolloClient = () => {
  client = client
    ? client
    : new ApolloClient({
        uri: `${getBaseUrl()}?language=${getPreference().language}`,
        cache: new InMemoryCache(),
      });

  return client;
};
